<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.ID }}</td>
                <td>{{ item.Username }}</td>
                <td class="text-end">{{ item.Package | currency }}</td>
                <td class="text-end">{{ item.Weight | currency }}</td>
                <td class="text-end">{{ item.Amount | currency}}</td>                
                <td class="text-end">{{ item.FeeShip | currency}}</td>                
                <td class="text-end">{{ item.OtherFee | currency}}</td>
                <td>{{ item.CreatedDate | display_date }}</td>
                <td class="text-center"><v-btn text icon color="orange lighten-2" @click="openPayDetail(item.ID)">
                    <v-icon>visibility</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogPayDetail" persistent max-width="800px">
            <v-card>
              <v-card-title>
                <span class="title">Chi tiết thanh toán #{{selected.ID}}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md pa-0>
                  <v-layout row wrap>
                    <v-flex lg12 class="font-weight-bold">
                      <div>Số lô thanh toán: {{selected.Packages.length | currency}}</div>
                    </v-flex>
                    <v-flex lg12>
                      <v-data-table
                        :headers="orderHeader"
                        :items="selected.Packages"
                        :mobile-breakpoint="100"
                        :items-per-page="100"
                        :hide-default-footer="true"
                        item-key="ID"
                      >
                        <template v-slot:item="{ item }">
                          <tr>                            
                            <td>
                              <a target="blank" href="/quan-ly-bao-hang">{{item.PackageCode}}</a>
                            </td>
                            <td class="text-end">{{ item.Weight | currency('', 1)}}</td>
                            <td class="text-end">{{ item.FeeUnit | currency}}</td>
                            <td class="text-end">{{ item.FeeShipVND | currency}}</td>
                            <td class="text-end">{{ item.Amount | currency}}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogPayDetail = false">Đóng</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      search: "",
      dialogPayDetail: false,
      headers: [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "User Name",
          value: "Username",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Số lô",
          value: "Package",
          quickSearch: true,
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cân/khối",
          value: "Weight",
          quickSearch: true,
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số tiền",
          value: "Amount",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        
        {
          text: "Phí ship",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí khác",
          value: "OtherFee",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ngày tạo",
          value: "CreatedDate",
          filterable: true,
          dataType: dataType["Date"]
        },
        {
          text: "Thao tác",
          align: "center",
          filterable: false,
        }    
      ],
      orderHeader: [
        {
          text: "Mã lô",
          value: "PackageCode",
          right: false
        },
        {
          text: "Cân/khối",
          value: "Weight",
          align: "end"
        },
        {
          text: "Đơn giá",
          value: "FeeUnit",
          align: "end"
        },
        {
          text: "Phí ship",
          value: "FeeShipVND",
          align: "end"
        },
        {
          text: "Thành tiền",
          value: "Amount",
          align: "end"
        }
      ],
      payment_type: configs.PAYMENT_STATUS_LIST,
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "payment_history_list",      
      filterConditions: [],
      quickFilterConditions: []
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    }
  },
  computed: mapState({
    items: state => state.paymentHistory.all.data,
    total_rows: state => state.paymentHistory.all.total,
    loading: state => state.paymentHistory.loading,
    selected: state => state.paymentHistory.selected
  }),
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        search_term: this.search,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("paymentHistory/getPaymentHistoryList", param);
    },
    gotoDetail: function(id) {
      this.$router.push({
        name: "PaymentHistoryDetail",
        params: { Pid: id, title: `Lịch sử thanh toán (#${id})` }
      });
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    get_type_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    openPayDetail(paymentID) {
      this.$store.dispatch("paymentHistory/getPaymentHistoryDetail", paymentID);
      this.dialogPayDetail = true;
    },
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>